module.exports = {
  CPF: require("./lib/cpf"),
  CNPJ: require("./lib/cnpj")
};



//////////////////
// WEBPACK FOOTER
// ./~/cpf_cnpj/index.js
// module id = 690
// module chunks = 1